export enum ETemplateExamDisplayType {
  Option = 'option',
  Input = 'input'
}
